var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fakebody"},[_c('a',{staticClass:"card",attrs:{"href":"https://magiceden.io/marketplace/sol_slugs"}},[_c('div',[_c('h3',{staticClass:"card-h3"},[_vm._v(_vm._s(_vm.symbol))]),_c('h2',{staticClass:"card-h2"},[_vm._v(_vm._s(_vm.floorPrice))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }